export default __webpack_public_path__ + "static/media/icon-line.632ce769.svg";